import { Link } from "react-router-dom"
import styled from "styled-components"


export const Title = styled.div`
    font-weight: bold;
    font-size: 15px;
    line-height: 38px;

    color: ${p => p.theme.colors.bg};
`

export const Item = styled(Link)`
    font-size: 14px;
    line-height: 30px;

    &, &:visited, &:active, &:hover {
        color: ${p => p.theme.colors.bg};
        opacity: 50%;
        text-decoration: none;
    }
`

export const ItemExternal = styled.a`
    font-size: 14px;
    line-height: 30px;

    &, &:visited, &:active, &:hover {
        color: ${p => p.theme.colors.bg};
        opacity: 50%;
        text-decoration: none;
    }
`

export const Block = styled.div`
    display: grid;
    height: max-content;
`